import styles from "./ThirdScreen.module.css"
import { useEffect, useRef } from "react"
import { Player } from "@lordicon/react"
import ScrollReveal from "scrollreveal"
import trophy from "../icons/wired-outline-1018-signature-sig-hover-pinch.json"
import growth from "../icons/wired-outline-1027-marketing-campaign-hover-jump (1).json"
import target from "../icons/wired-outline-2610-lead-generation-hover-pinch.json"
import community from"../icons/wired-outline-2342-hugging-love-hover-pinch.json"
import rocket from "../icons/wired-outline-152-bar-chart-arrow-hover-growth (1).json"
import Button from "../components/button/Button"

const ThirdScreen = () => {
    const playerRef1 = useRef()
    const playerRef2 = useRef()
    const playerRef3 = useRef()
    const playerRef4 = useRef()
    const playerRef5 = useRef()
    
    useEffect(() => {
        ScrollReveal().reveal(`.${styles.title}`, {
            duration: 1000,
            distance: "30px",
            origin: "top",
            easing: "ease-out",
            reset: false,
            viewFactor: 0.2,
            interval: 300,
            delay: 200,
            scale: 1,
        });
        ScrollReveal().reveal(`.${styles.section}`, {
            duration: 1000,
            distance: "30px",
            origin: "right",
            easing: "ease-in-out",
            reset: false,
            viewFactor: 0.2,
            interval: 300,
            delay: 200,
            scale: 1,
        });
        ScrollReveal().reveal(`.${styles.stepHeader}`, {
            duration: 1000,
            distance: "30px",
            origin: "top",
            easing: "ease-in-out",
            reset: false,
            viewFactor: 0.2,
            interval: 300,
            delay: 200,
            scale: 1,
        });
        
        playerRef1.current?.playFromBeginning();
        playerRef2.current?.playFromBeginning();
        playerRef3.current?.playFromBeginning();
        playerRef4.current?.playFromBeginning();    
        playerRef5.current?.playFromBeginning();  
    }, [])

    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <div className={styles.titleContainer}>
                    <h2 className={styles.title}>
                        <span className={styles.titleWhite}>אז מה יקרה לעסק שלך ברגע </span>
                        <span className={styles.titleHighlight}>שתהפוך למותג ברשתות</span>
                    </h2>
                </div>

                <div className={styles.bigWrapper}>
                    <div className={styles.step} itemScope itemType="https://schema.org/Thing">
                        <div className={styles.icons}>
                            <Player 
                                ref={playerRef1} 
                                size="100%" 
                                onComplete={() => playerRef1.current?.playFromBeginning()} 
                                icon={trophy} 
                            />
                        </div>
                        <div className={styles.text}>
                            <div className={styles.stepHeader} itemProp="name">
                                תבנה מוניטין חזק ומקצועי
                            </div>
                            <div className={styles.section} itemProp="description">
                                תוכן איכותי ועקבי יבנה את המותג שלך כמומחה בתחום. לקוחות פוטנציאליים יראו את המקצועיות והמחוייבות שלך, מה שייצור אמון ויעלה את הסיכוי שיבחרו בך על פני המתחרים
                            </div>
                        </div>
                    </div>

                    <div className={styles.step} itemScope itemType="https://schema.org/Thing">
                        <div className={styles.text}>
                            <div className={styles.stepHeader} itemProp="name">
                               נתוני החשיפה שלך יעלו והלקוחות יבואו
                            </div>
                            <div className={styles.section} itemProp="description">
האלגוריתמים של הרשתות אוהבים תוכן איכותי, מגוון ועקביות. ברגע שהפרסומים יעלו באופן סדיר ואיכותי, החשיפה תתרחב ותגיע לאנשים הנכונים עבור העסק שלך ויצרו עבורך קהילה נאמר שתחכה לכל פרסום שלך
                            </div>
                        </div>
                        <div className={styles.icons}>
                            <Player 
                                ref={playerRef2} 
                                delay={500} 
                                size="100%" 
                                onComplete={() => playerRef2.current?.playFromBeginning()} 
                                icon={growth} 
                            />
                        </div>
                    </div>

                    <div className={styles.step} itemScope itemType="https://schema.org/Thing">
                        <div className={styles.icons}>
                            <Player 
                                ref={playerRef3} 
                                size="100%" 
                                onComplete={() => playerRef3.current?.playFromBeginning()} 
                                icon={target} 
                            />
                        </div>
                        <div className={styles.text}>
                            <div className={styles.stepHeader} itemProp="name">
                                הלידים שתקבל יהיו רותחים והפניות ממוקדות
                            </div>
                            <div className={styles.section} itemProp="description">
                                תוכן מדויק ורלוונטי ימשוך את הלקוחות הנכונים - אלו שבאמת מתעניינים בשירות שלך. במקום לרדוף אחרי כולם, תקבל פניות ממוקדות מאנשים שכבר מכירים ומעריכים את מה שאתה מציע
                            </div>
                        </div>
                    </div>

                    <div className={styles.step} itemScope itemType="https://schema.org/Thing">
                        <div className={styles.text}>
                            <div className={styles.stepHeader} itemProp="name">
                             הלקוחות ידעו מי אתה ויאהבו אותך
                            </div>
                            <div className={styles.section} itemProp="description">
                              בתקופה של היום אנשים רוצים לקבל שירות מבעל עסק שהם מתחברים אליו וסומכים עליו. נוכחות מדוייקת ברשתות החברתיות תגרום לך להבין את הצרכים והרצונות של הלקוחות, לענות על שאלות בזמן אמת וליצור קשרים אמיתיים עם הלקוחות שלך
                            </div>
                        </div>
                        <div className={styles.icons}>
                            <Player 
                                ref={playerRef4} 
                                delay={500} 
                                size="100%" 
                                onComplete={() => playerRef4.current?.playFromBeginning()} 
                                icon={community} 
                            />
                        </div>
                    </div>

                    <div className={styles.step} itemScope itemType="https://schema.org/Thing">
                        <div className={styles.icons}>
                            <Player 
                                ref={playerRef5} 
                                size="100%" 
                                onComplete={() => playerRef5.current?.playFromBeginning()} 
                                icon={rocket} 
                            />
                        </div>
                        <div className={styles.text}>
                            <div className={styles.stepHeader} itemProp="name">
                                תחווה צמיחה עסקית מתמשכת
                            </div>
                            <div className={styles.section} itemProp="description">
                                נוכחות חזקה ברשתות החברתיות זה לא רק שיווק - זה מנוע הצמיחה שלך. כל פוסט, כל שיתוף, כל תגובה ירחיבו את טווח ההגעה שלך ויביאו לך עוד הזדמנויות עסקיות, שיתופי פעולה ולקוחות חדשים
                            </div>
                        </div>
                    </div>
                </div>
                
                <Button text="בואו נעלה את העסק שלך רמה!"/>
            </div>
        </div>
    )
}

export default ThirdScreen